/* GENERATED — durations synced from the live Phorest booking data 22 Jul 2026.
   Booking-slot durations (incl. turnaround); named-duration massages show face value.
   Prices are display-only 'from' prices — Phorest is the booking source of truth. */
window.PBTreatments = {
 "categories": [
  "Eventis",
  "Skin Health",
  "Environ",
  "Elemis",
  "Caci",
  "Peels",
  "Mesotherapy",
  "LPG",
  "Laser Hair Removal",
  "Waxing",
  "Lashes",
  "Brows & Tinting",
  "Semi-Permanent Make-Up",
  "Nails",
  "Spray Tan",
  "Make Up Lesson",
  "Ear Piercing",
  "Threading",
  "Skin Tag Removal",
  "Wellbeing",
  "Pregnancy"
 ],
 "treatments": [
  {
   "id": "skinpen",
   "cat": "Skin Health",
   "name": "SkinPen Microneedling",
   "duration": 90,
   "price": 225,
   "desc": "Collagen-stimulation therapy for long-lasting rejuvenation, scarring and skin renewal.",
   "concerns": [
    "ageing",
    "acne",
    "pigmentation"
   ]
  },
  {
   "id": "massage-30",
   "cat": "Wellbeing",
   "name": "30 Minute Massage",
   "duration": 30,
   "price": 40,
   "desc": "A focused 30-minute massage to ease tension where you need it most.",
   "concerns": []
  },
  {
   "id": "massage-60",
   "cat": "Wellbeing",
   "name": "60 Minute Massage",
   "duration": 60,
   "price": 65,
   "desc": "A full hour of relaxing massage tailored to your needs.",
   "concerns": []
  },
  {
   "id": "massage-90",
   "cat": "Wellbeing",
   "name": "90 Minute Massage",
   "duration": 90,
   "price": 100,
   "desc": "An extended 90-minute massage for complete head-to-toe relaxation.",
   "concerns": []
  },
  {
   "id": "massage-full-body",
   "cat": "Wellbeing",
   "name": "Full Body Massage",
   "duration": 75,
   "price": 65,
   "desc": "A soothing full-body massage to unwind and restore.",
   "concerns": []
  },
  {
   "id": "massage-hot-stone",
   "cat": "Wellbeing",
   "name": "Hot Stone Massage",
   "duration": 75,
   "price": 65,
   "desc": "Warm basalt stones melt away tension for deep, comforting relaxation.",
   "concerns": []
  },
  {
   "id": "massage-hot-stone-60",
   "cat": "Wellbeing",
   "name": "60 Minute Hot Stones Massage",
   "duration": 60,
   "price": 75,
   "desc": "A 60-minute hot stones massage to soothe muscles and calm the mind.",
   "concerns": []
  },
  {
   "id": "massage-hot-stone-90",
   "cat": "Wellbeing",
   "name": "90 Minute Hot Stones Massage",
   "duration": 90,
   "price": 120,
   "desc": "An indulgent 90-minute hot stones massage for total escape.",
   "concerns": []
  },
  {
   "id": "massage-lava-60",
   "cat": "Wellbeing",
   "name": "60 Minute Lava Shell Massage",
   "duration": 60,
   "price": 75,
   "desc": "Self-heating lava shells glide over the body for deep, warming relief.",
   "concerns": []
  },
  {
   "id": "massage-lava-90",
   "cat": "Wellbeing",
   "name": "90 Minute Lava Shell Massage",
   "duration": 90,
   "price": 120,
   "desc": "An extended lava shell massage for the ultimate warm, restorative treat.",
   "concerns": []
  },
  {
   "id": "massage-deep-tissue",
   "cat": "Wellbeing",
   "name": "Deep Tissue Back, Neck & Shoulder Massage",
   "duration": 45,
   "price": 40,
   "desc": "A targeted deep-tissue massage to release stubborn tension in the back, neck and shoulders.",
   "concerns": []
  },
  {
   "id": "massage-swedish-bns",
   "cat": "Wellbeing",
   "name": "Swedish Back, Neck & Shoulder Massage",
   "duration": 45,
   "price": 40,
   "desc": "A classic Swedish massage focusing on the back, neck and shoulders.",
   "concerns": []
  },
  {
   "id": "massage-swedish-full",
   "cat": "Wellbeing",
   "name": "Swedish Full Body Massage",
   "duration": 75,
   "price": 65,
   "desc": "A full-body Swedish massage to relax muscles and boost circulation.",
   "concerns": []
  },
  {
   "id": "massage-lymph-detox",
   "cat": "Wellbeing",
   "name": "Mechanical Lymphatic Detox Drain LPG",
   "duration": 40,
   "price": 80,
   "desc": "LPG mechanical lymphatic drainage to detoxify, de-puff and revitalise.",
   "concerns": []
  },
  {
   "id": "massage-lymph-lpg",
   "cat": "Wellbeing",
   "name": "Mechanical Lymphatic Drainage Massage & 50 Minutes LPG",
   "duration": 75,
   "price": 100,
   "desc": "A combined lymphatic drainage massage with 50 minutes of LPG for maximum results.",
   "concerns": []
  },
  {
   "id": "pedi-luxury",
   "cat": "Wellbeing",
   "name": "Luxury Pedicure",
   "duration": 75,
   "price": 54,
   "desc": "A pampering luxury pedicure to soften, smooth and refresh tired feet.",
   "concerns": []
  },
  {
   "id": "pedi-gel",
   "cat": "Wellbeing",
   "name": "Pedicure with Gel",
   "duration": 60,
   "price": 30,
   "desc": "A relaxing pedicure finished with long-lasting gel colour \u2014 from \u00a330.",
   "concerns": []
  },
  {
   "id": "pedi-gel-soak",
   "cat": "Wellbeing",
   "name": "Pedicure with Gel Soak Off",
   "duration": 75,
   "price": 33,
   "desc": "A pedicure including gel removal and reapplication \u2014 from \u00a333.",
   "concerns": []
  },
  {
   "id": "pedi-polish",
   "cat": "Wellbeing",
   "name": "Pedicure with Polish",
   "duration": 60,
   "price": 30,
   "desc": "A classic pedicure finished with a polish of your choice \u2014 from \u00a330.",
   "concerns": []
  },
  {
   "id": "pedi-gel-toes",
   "cat": "Wellbeing",
   "name": "Gel Colour Toes",
   "duration": 45,
   "price": 30,
   "desc": "Long-lasting gel colour applied to the toes.",
   "concerns": []
  },
  {
   "id": "preg-peaceful",
   "cat": "Pregnancy",
   "name": "Elemis Peaceful Pregnancy Massage",
   "duration": 90,
   "price": 75,
   "desc": "A nurturing Elemis massage designed to soothe mums-to-be.",
   "concerns": []
  },
  {
   "id": "preg-safe-facial",
   "cat": "Pregnancy",
   "name": "Elemis Pregnancy Safe Facial",
   "duration": 75,
   "price": 65,
   "desc": "A pregnancy-safe Elemis facial to relax and revitalise the skin.",
   "concerns": [
    "sensitive",
    "dryness"
   ]
  },
  {
   "id": "preg-deluxe",
   "cat": "Pregnancy",
   "name": "Pregnancy Deluxe",
   "duration": 75,
   "price": 70,
   "desc": "An indulgent deluxe pregnancy treatment for complete relaxation.",
   "concerns": []
  },
  {
   "id": "preg-massage",
   "cat": "Pregnancy",
   "name": "Pregnancy Massage",
   "duration": 45,
   "price": 50,
   "desc": "A gentle massage tailored to the needs of expectant mums.",
   "concerns": []
  },
  {
   "id": "eventis-facial",
   "cat": "Eventis",
   "name": "Eventis Skin Scan with Bespoke 60 Minute Facial",
   "duration": 120,
   "price": 120,
   "desc": "An in-depth Eventis skin scan followed by a bespoke 60-minute facial tailored to what your skin reveals.",
   "concerns": [
    "ageing",
    "pigmentation",
    "redness"
   ]
  },
  {
   "id": "eventis-consult",
   "cat": "Eventis",
   "name": "Eventis Skin Scan with Full Consultation (No Facial)",
   "duration": 45,
   "price": 20,
   "desc": "A detailed Eventis skin scan and full consultation to map your skin and plan your routine \u2014 no facial.",
   "concerns": [
    "ageing",
    "pigmentation"
   ]
  },
  {
   "id": "env-comfort-calm",
   "cat": "Environ",
   "name": "Environ Comfort Calm Facial",
   "duration": 75,
   "price": 70,
   "desc": "A soothing Environ facial to calm and comfort sensitive, reactive skin.",
   "concerns": [
    "sensitive",
    "redness"
   ]
  },
  {
   "id": "env-moisture-boost",
   "cat": "Environ",
   "name": "Environ Moisture Boost",
   "duration": 75,
   "price": 70,
   "desc": "A hydrating Environ facial to replenish and plump dry, dehydrated skin.",
   "concerns": [
    "dryness"
   ]
  },
  {
   "id": "env-radiance-reveal",
   "cat": "Environ",
   "name": "Environ Radiance Reveal",
   "duration": 75,
   "price": 70,
   "desc": "A brightening Environ facial to reveal a smoother, more radiant complexion.",
   "concerns": [
    "pigmentation",
    "ageing"
   ]
  },
  {
   "id": "env-youth-reset",
   "cat": "Environ",
   "name": "Environ Youth Reset",
   "duration": 75,
   "price": 70,
   "desc": "An age-defying Environ facial to firm, smooth and renew mature skin.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "lpg-assessment",
   "cat": "LPG",
   "name": "LPG Personal Assessment",
   "duration": 30,
   "price": 20,
   "desc": "A personalised LPG assessment to plan the right body or face programme for your goals.",
   "concerns": []
  },
  {
   "id": "lpg-custom-body",
   "cat": "LPG",
   "name": "LPG Customised Body Treatment",
   "duration": 60,
   "price": 70,
   "desc": "A tailored LPG Endermologie body session \u2014 from \u00a370, targeting your chosen concern.",
   "concerns": []
  },
  {
   "id": "lpg-cellulite",
   "cat": "LPG",
   "name": "LPG Signature Body Cellulite Smoothing",
   "duration": 60,
   "price": 95,
   "desc": "Patented Endermologie to visibly smooth cellulite and refine the skin's surface.",
   "concerns": []
  },
  {
   "id": "lpg-resculpt",
   "cat": "LPG",
   "name": "LPG Signature Body Resculpt & Firm",
   "duration": 75,
   "price": 105,
   "desc": "A contouring, firming LPG treatment to resculpt and tighten the body.",
   "concerns": []
  },
  {
   "id": "lpg-deep-tissue",
   "cat": "LPG",
   "name": "LPG Wellness Deep Tissue Recovery",
   "duration": 60,
   "price": 100,
   "desc": "A deep-tissue LPG wellness session to release tension and aid muscle recovery.",
   "concerns": []
  },
  {
   "id": "lpg-detox",
   "cat": "LPG",
   "name": "LPG Wellness Draining Detox",
   "duration": 60,
   "price": 80,
   "desc": "A lymphatic-draining LPG treatment to detoxify, de-puff and revitalise.",
   "concerns": []
  },
  {
   "id": "lpg-intense",
   "cat": "LPG",
   "name": "LPG Wellness Intense Wellness",
   "duration": 60,
   "price": 100,
   "desc": "An intensive full-body LPG wellness session for deep relaxation and renewal.",
   "concerns": []
  },
  {
   "id": "lpg-upper-body",
   "cat": "LPG",
   "name": "LPG Wellness Upper Body Relaxation",
   "duration": 45,
   "price": 60,
   "desc": "A focused LPG treatment to release tension across the neck, shoulders and back.",
   "concerns": []
  },
  {
   "id": "lpg-vss",
   "cat": "LPG",
   "name": "LPG Wellness VSS Vitality Stress Sleep",
   "duration": 60,
   "price": 80,
   "desc": "An LPG wellness ritual to boost vitality, ease stress and support better sleep.",
   "concerns": []
  },
  {
   "id": "peel-vibrant-c",
   "cat": "Peels",
   "name": "Vibrant-C Micro Peel",
   "duration": 60,
   "price": 75,
   "desc": "A brightening vitamin C micro peel to refresh, even tone and restore radiance \u2014 no downtime.",
   "concerns": [
    "pigmentation",
    "ageing"
   ]
  },
  {
   "id": "peel-tca-youth",
   "cat": "Peels",
   "name": "Youth Renew TCA Cool Peel",
   "duration": 75,
   "price": 85,
   "desc": "A resurfacing TCA cool peel to smooth texture, soften lines and renew mature skin.",
   "concerns": [
    "ageing",
    "pigmentation"
   ]
  },
  {
   "id": "laser-hair-removal-laser-hair-removal-consultation",
   "cat": "Laser Hair Removal",
   "name": "Laser Hair Removal Consultation",
   "duration": 30,
   "price": 25,
   "desc": "A consultation and test patch to plan your laser hair removal course.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-upper-lip",
   "cat": "Laser Hair Removal",
   "name": "Upper Lip",
   "duration": 30,
   "price": 25,
   "desc": "Upper Lip at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-chin",
   "cat": "Laser Hair Removal",
   "name": "Chin",
   "duration": 30,
   "price": 25,
   "desc": "Chin at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-side-of-face",
   "cat": "Laser Hair Removal",
   "name": "Side of Face",
   "duration": 30,
   "price": 25,
   "desc": "Side of Face at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-neck",
   "cat": "Laser Hair Removal",
   "name": "Neck",
   "duration": 30,
   "price": 25,
   "desc": "Neck at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-any-2-facial-areas",
   "cat": "Laser Hair Removal",
   "name": "Any 2 Facial Areas",
   "duration": 30,
   "price": 40,
   "desc": "Any 2 Facial Areas at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-beard",
   "cat": "Laser Hair Removal",
   "name": "Beard",
   "duration": 30,
   "price": 50,
   "desc": "Beard at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-underarms",
   "cat": "Laser Hair Removal",
   "name": "Underarms",
   "duration": 30,
   "price": 35,
   "desc": "Underarms at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-forearm-half-arm",
   "cat": "Laser Hair Removal",
   "name": "Forearm (Half Arm)",
   "duration": 30,
   "price": 40,
   "desc": "Forearm (Half Arm) at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-full-arm",
   "cat": "Laser Hair Removal",
   "name": "Full Arm",
   "duration": 45,
   "price": 60,
   "desc": "Full Arm at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-bikini-line",
   "cat": "Laser Hair Removal",
   "name": "Bikini Line",
   "duration": 30,
   "price": 45,
   "desc": "Bikini Line at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-brazilian",
   "cat": "Laser Hair Removal",
   "name": "Brazilian",
   "duration": 30,
   "price": 60,
   "desc": "Brazilian at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hollywood",
   "cat": "Laser Hair Removal",
   "name": "Hollywood",
   "duration": 30,
   "price": 70,
   "desc": "Hollywood at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-hollywood-underarm",
   "cat": "Laser Hair Removal",
   "name": "Hollywood & Underarm",
   "duration": 60,
   "price": 90,
   "desc": "Hollywood & Underarm at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-half-leg",
   "cat": "Laser Hair Removal",
   "name": "Half Leg",
   "duration": 30,
   "price": 70,
   "desc": "Half Leg at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-full-leg",
   "cat": "Laser Hair Removal",
   "name": "Full Leg",
   "duration": 45,
   "price": 95,
   "desc": "Full Leg at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-half-leg-hollywood-underarm",
   "cat": "Laser Hair Removal",
   "name": "Half Leg, Hollywood & Underarm",
   "duration": 75,
   "price": 120,
   "desc": "Half Leg, Hollywood & Underarm at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-full-leg-hollywood-underarm",
   "cat": "Laser Hair Removal",
   "name": "Full Leg, Hollywood & Underarm",
   "duration": 90,
   "price": 120,
   "desc": "Full Leg, Hollywood & Underarm at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-underarm-full-leg",
   "cat": "Laser Hair Removal",
   "name": "Underarm & Full Leg",
   "duration": 75,
   "price": 115,
   "desc": "Underarm & Full Leg at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-stomach-line",
   "cat": "Laser Hair Removal",
   "name": "Stomach Line",
   "duration": 30,
   "price": 50,
   "desc": "Stomach Line at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-buttocks",
   "cat": "Laser Hair Removal",
   "name": "Buttocks",
   "duration": 30,
   "price": 60,
   "desc": "Buttocks at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-chest",
   "cat": "Laser Hair Removal",
   "name": "Chest",
   "duration": 45,
   "price": 80,
   "desc": "Chest at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-upper-lower-back",
   "cat": "Laser Hair Removal",
   "name": "Upper / Lower Back",
   "duration": 40,
   "price": 80,
   "desc": "Upper / Lower Back at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "laser-hair-removal-full-back",
   "cat": "Laser Hair Removal",
   "name": "Full Back",
   "duration": 60,
   "price": 160,
   "desc": "Full Back at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "lpg-face-custom",
   "cat": "LPG",
   "name": "LPG Customised Face Treatment",
   "duration": 60,
   "price": 60,
   "desc": "A tailored LPG Endermologie facial \u2014 from \u00a360.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "lpg-lpg-essential-endermo-cellular-prevention",
   "cat": "LPG",
   "name": "LPG Essential Endermo Cellular Prevention",
   "duration": 45,
   "price": 65,
   "desc": "LPG Essential Endermo Cellular Prevention at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "lpg-lpg-essential-endermo-glow-booster",
   "cat": "LPG",
   "name": "LPG Essential Endermo Glow Booster",
   "duration": 45,
   "price": 65,
   "desc": "LPG Essential Endermo Glow Booster at Pure Birkdale.",
   "concerns": [
    "pigmentation"
   ]
  },
  {
   "id": "lpg-lpg-essential-endermo-plump",
   "cat": "LPG",
   "name": "LPG Essential Endermo Plump",
   "duration": 60,
   "price": 85,
   "desc": "LPG Essential Endermo Plump at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "lpg-lpg-essentials-endermo-eyes-and-lips",
   "cat": "LPG",
   "name": "LPG Essentials Endermo Eyes and Lips",
   "duration": 60,
   "price": 80,
   "desc": "LPG Essentials Endermo Eyes and Lips at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "lpg-lpg-signature-hydration-booster",
   "cat": "LPG",
   "name": "LPG Signature Hydration Booster",
   "duration": 60,
   "price": 65,
   "desc": "LPG Signature Hydration Booster at Pure Birkdale.",
   "concerns": [
    "dryness"
   ]
  },
  {
   "id": "lpg-lpg-signature-pro-lift",
   "cat": "LPG",
   "name": "LPG Signature Pro Lift",
   "duration": 90,
   "price": 115,
   "desc": "LPG Signature Pro Lift at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "lpg-lpg-signature-skin-renewal",
   "cat": "LPG",
   "name": "LPG Signature Skin Renewal",
   "duration": 90,
   "price": 110,
   "desc": "LPG Signature Skin Renewal at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "lvl-lash-lift",
   "cat": "Lashes",
   "name": "LVL Lash Lift",
   "duration": 60,
   "price": 45,
   "desc": "LVL Lash Lift at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "lashes-korean-lash-lift",
   "cat": "Lashes",
   "name": "Korean Lash Lift",
   "duration": 60,
   "price": 50,
   "desc": "Korean Lash Lift at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "lashes-lvl-lash-lift-brow-lamination",
   "cat": "Lashes",
   "name": "LVL Lash Lift & Brow Lamination",
   "duration": 60,
   "price": 70,
   "desc": "LVL Lash Lift & Brow Lamination at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "caci-caci-new-synergy-non-surgical-face-lift",
   "cat": "Caci",
   "name": "Caci (New Synergy) Non-Surgical Face Lift",
   "duration": 75,
   "price": 70,
   "desc": "Caci (New Synergy) Non-Surgical Face Lift at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "caci-caci-eye-treatment",
   "cat": "Caci",
   "name": "Caci Eye Treatment",
   "duration": 45,
   "price": 45,
   "desc": "Caci Eye Treatment at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "caci-caci-jowl-lift",
   "cat": "Caci",
   "name": "Caci Jowl Lift",
   "duration": 45,
   "price": 45,
   "desc": "Caci Jowl Lift at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "caci-environ-caci-super-facial",
   "cat": "Caci",
   "name": "Environ & Caci Super Facial",
   "duration": 90,
   "price": 90,
   "desc": "Environ & Caci Super Facial at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "elemis-elemis-expert-touch-nourish-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Touch Nourish Facial",
   "duration": 75,
   "price": 60,
   "desc": "NEW Elemis Expert Touch facial to nourish and comfort \u2014 from \u00a360.",
   "concerns": [
    "dryness"
   ]
  },
  {
   "id": "elemis-elemis-expert-touch-define-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Touch Define Facial",
   "duration": 75,
   "price": 60,
   "desc": "NEW Elemis Expert Touch Define facial \u2014 from \u00a360.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "elemis-elemis-expert-touch-define-facial-plus",
   "cat": "Elemis",
   "name": "Elemis Expert Touch Define Facial Plus",
   "duration": 90,
   "price": 85,
   "desc": "NEW Elemis Expert Touch Define Plus facial \u2014 from \u00a385.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "elemis-elemis-expert-touch-renew-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Touch Renew Facial",
   "duration": 75,
   "price": 60,
   "desc": "NEW Elemis Expert Touch Renew facial \u2014 from \u00a360.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "elemis-elemis-expert-touch-reveal-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Touch Reveal Facial",
   "duration": 75,
   "price": 60,
   "desc": "NEW Elemis Expert Touch Reveal facial \u2014 from \u00a360.",
   "concerns": [
    "pigmentation"
   ]
  },
  {
   "id": "elemis-elemis-expert-tech-lift-rejuvenate-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Tech Lift + Rejuvenate Facial",
   "duration": 75,
   "price": 75,
   "desc": "Elemis Expert Tech Lift + Rejuvenate Facial at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "elemis-elemis-expert-tech-radiance-revive-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Tech Radiance + Revive Facial",
   "duration": 75,
   "price": 75,
   "desc": "Elemis Expert Tech Radiance + Revive Facial at Pure Birkdale.",
   "concerns": [
    "pigmentation"
   ]
  },
  {
   "id": "elemis-elemis-expert-tech-sculpt-firm-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Tech Sculpt + Firm Facial",
   "duration": 75,
   "price": 75,
   "desc": "Elemis Expert Tech Sculpt + Firm Facial at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "elemis-elemis-expert-tech-sculpt-firm-facial-plus",
   "cat": "Elemis",
   "name": "Elemis Expert Tech Sculpt + Firm Facial Plus",
   "duration": 90,
   "price": 85,
   "desc": "Elemis Expert Tech Sculpt + Firm Facial Plus at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "elemis-elemis-expert-tech-smooth-polish-facial",
   "cat": "Elemis",
   "name": "Elemis Expert Tech Smooth + Polish Facial",
   "duration": 75,
   "price": 75,
   "desc": "Elemis Expert Tech Smooth + Polish Facial at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "mesotherapy-red-carpet-meso-facial",
   "cat": "Mesotherapy",
   "name": "Red Carpet Meso Facial",
   "duration": 75,
   "price": 120,
   "desc": "Red Carpet Meso Facial at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "mesotherapy-fillmed-beautifeye",
   "cat": "Mesotherapy",
   "name": "Fillmed Beautifeye",
   "duration": 60,
   "price": 120,
   "desc": "Fillmed Beautifeye at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "mesotherapy-fillmed-bio-nutrineck",
   "cat": "Mesotherapy",
   "name": "Fillmed Bio Nutrineck",
   "duration": 60,
   "price": 150,
   "desc": "Fillmed Bio Nutrineck at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "mesotherapy-beautifeye-bio-nutrineck",
   "cat": "Mesotherapy",
   "name": "Beautifeye & Bio Nutrineck",
   "duration": 30,
   "price": 210,
   "desc": "Beautifeye & Bio Nutrineck at Pure Birkdale.",
   "concerns": [
    "ageing"
   ]
  },
  {
   "id": "spmu-consult",
   "cat": "Semi-Permanent Make-Up",
   "name": "Consultation for Semi-Permanent Make-Up",
   "duration": 15,
   "price": 0,
   "desc": "A consultation to plan your semi-permanent make-up.",
   "concerns": []
  },
  {
   "id": "semi-permanent-make-up-microblading",
   "cat": "Semi-Permanent Make-Up",
   "name": "Microblading",
   "duration": 120,
   "price": 250,
   "desc": "Microblading at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "semi-permanent-make-up-nano-brows",
   "cat": "Semi-Permanent Make-Up",
   "name": "Nano Brows",
   "duration": 120,
   "price": 250,
   "desc": "Nano Brows at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "semi-permanent-make-up-ombr-brows",
   "cat": "Semi-Permanent Make-Up",
   "name": "Ombr\u00e9 Brows",
   "duration": 120,
   "price": 250,
   "desc": "Ombr\u00e9 Brows at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "semi-permanent-make-up-lip-blush",
   "cat": "Semi-Permanent Make-Up",
   "name": "Lip Blush",
   "duration": 120,
   "price": 250,
   "desc": "Lip Blush at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "spmu-brow-lamination",
   "cat": "Semi-Permanent Make-Up",
   "name": "Brow Lamination",
   "duration": 45,
   "price": 35,
   "desc": "Brow Lamination at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "semi-permanent-make-up-semi-permanent-make-up-top-up",
   "cat": "Semi-Permanent Make-Up",
   "name": "Semi-Permanent Make-Up Top Up",
   "duration": 120,
   "price": 75,
   "desc": "Semi-Permanent Make-Up Top Up at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "spray-tan-vita-liberata-spray-tan",
   "cat": "Spray Tan",
   "name": "Vita Liberata Spray Tan",
   "duration": 15,
   "price": 25,
   "desc": "Vita Liberata Spray Tan at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "brows-tinting-eyebrow-hot-wax",
   "cat": "Brows & Tinting",
   "name": "Eyebrow Hot Wax",
   "duration": 15,
   "price": 12,
   "desc": "Eyebrow Hot Wax at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "brows-tinting-eyebrow-tint",
   "cat": "Brows & Tinting",
   "name": "Eyebrow Tint",
   "duration": 15,
   "price": 15,
   "desc": "Eyebrow Tint at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "brows-tinting-eyelash-tint",
   "cat": "Brows & Tinting",
   "name": "Eyelash Tint",
   "duration": 15,
   "price": 18,
   "desc": "Eyelash Tint at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "brows-tinting-weekend-lashes",
   "cat": "Brows & Tinting",
   "name": "Weekend Lashes",
   "duration": 30,
   "price": 20,
   "desc": "Weekend Lashes at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "brows-tinting-eyebrow-shape-tint",
   "cat": "Brows & Tinting",
   "name": "Eyebrow Shape & Tint",
   "duration": 15,
   "price": 22,
   "desc": "Eyebrow Shape & Tint at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "brows-tinting-eyelash-eyebrow-tint",
   "cat": "Brows & Tinting",
   "name": "Eyelash & Eyebrow Tint",
   "duration": 30,
   "price": 30,
   "desc": "Eyelash & Eyebrow Tint at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "brows-tinting-eyebrow-shape-tint-lash-tint",
   "cat": "Brows & Tinting",
   "name": "Eyebrow Shape, Tint & Lash Tint",
   "duration": 30,
   "price": 30,
   "desc": "Eyebrow Shape, Tint & Lash Tint at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "bt-brow-lamination",
   "cat": "Brows & Tinting",
   "name": "Brow Lamination",
   "duration": 45,
   "price": 40,
   "desc": "Brow Lamination at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "brows-tinting-henna-brows",
   "cat": "Brows & Tinting",
   "name": "Henna Brows",
   "duration": 45,
   "price": 40,
   "desc": "Henna Brows at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "makeup-lesson",
   "cat": "Make Up Lesson",
   "name": "et al. Make Up Lesson",
   "duration": 45,
   "price": 15,
   "desc": "A personalised et al. make-up lesson \u2014 from \u00a315.",
   "concerns": []
  },
  {
   "id": "ear-piercing",
   "cat": "Ear Piercing",
   "name": "Ear Piercing",
   "duration": 30,
   "price": 40,
   "desc": "Ear piercing \u2014 from \u00a340.",
   "concerns": []
  },
  {
   "id": "cryopen-consult",
   "cat": "Skin Tag Removal",
   "name": "CryoPen Consultation",
   "duration": 30,
   "price": 0,
   "desc": "A CryoPen consultation for skin tag and lesion removal.",
   "concerns": []
  },
  {
   "id": "threading",
   "cat": "Threading",
   "name": "Threading (Lip, Chin or Eyebrow)",
   "duration": 15,
   "price": 12,
   "desc": "Threading (Lip, Chin or Eyebrow) at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "waxing-lip-or-chin-hot-wax",
   "cat": "Waxing",
   "name": "Lip or Chin Hot Wax",
   "duration": 15,
   "price": 12,
   "desc": "Lip or Chin Hot Wax at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "waxing-underarm-hot-wax",
   "cat": "Waxing",
   "name": "Underarm Hot Wax",
   "duration": 15,
   "price": 12,
   "desc": "Underarm Hot Wax at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "wax-half-leg",
   "cat": "Waxing",
   "name": "Half Leg",
   "duration": 30,
   "price": 19,
   "desc": "Half Leg at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "wax-bikini-line",
   "cat": "Waxing",
   "name": "Bikini Line",
   "duration": 30,
   "price": 20,
   "desc": "Bikini Line at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "wax-forearm",
   "cat": "Waxing",
   "name": "Forearm",
   "duration": 30,
   "price": 20,
   "desc": "Forearm at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "waxing-lip-chin",
   "cat": "Waxing",
   "name": "Lip & Chin",
   "duration": 30,
   "price": 20,
   "desc": "Lip & Chin at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "waxing-back-or-chest",
   "cat": "Waxing",
   "name": "Back or Chest",
   "duration": 30,
   "price": 25,
   "desc": "Back or chest waxing \u2014 from \u00a325.",
   "concerns": []
  },
  {
   "id": "waxing-full-face-hot-wax",
   "cat": "Waxing",
   "name": "Full Face Hot Wax",
   "duration": 30,
   "price": 25,
   "desc": "Full Face Hot Wax at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "wax-full-leg",
   "cat": "Waxing",
   "name": "Full Leg",
   "duration": 45,
   "price": 28,
   "desc": "Full Leg at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "waxing-lip-chin-brow-wax-tint",
   "cat": "Waxing",
   "name": "Lip, Chin, Brow Wax & Tint",
   "duration": 30,
   "price": 32,
   "desc": "Lip, Chin, Brow Wax & Tint at Pure Birkdale.",
   "concerns": [],
   "patch": true
  },
  {
   "id": "waxing-half-leg-bikini",
   "cat": "Waxing",
   "name": "Half Leg & Bikini",
   "duration": 30,
   "price": 33,
   "desc": "Half Leg & Bikini at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "wax-brazilian",
   "cat": "Waxing",
   "name": "Brazilian Hot Wax",
   "duration": 30,
   "price": 35,
   "desc": "Brazilian Hot Wax at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "wax-hollywood",
   "cat": "Waxing",
   "name": "Hollywood Wax",
   "duration": 30,
   "price": 35,
   "desc": "Hollywood Wax at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-nail-repair-gel-biab",
   "cat": "Nails",
   "name": "Nail Repair Gel / BIAB",
   "duration": 15,
   "price": 5,
   "desc": "Nail Repair Gel / BIAB at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-repair-acrylic",
   "cat": "Nails",
   "name": "Repair Acrylic",
   "duration": 15,
   "price": 5,
   "desc": "Repair Acrylic at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-gel-shellac-removal",
   "cat": "Nails",
   "name": "Gel / Shellac Removal",
   "duration": 30,
   "price": 10,
   "desc": "Gel / Shellac Removal at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-nail-art-add-on",
   "cat": "Nails",
   "name": "Nail Art (Add-On)",
   "duration": 15,
   "price": 10,
   "desc": "Nail Art (Add-On) at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-acrylic-removal",
   "cat": "Nails",
   "name": "Acrylic Removal",
   "duration": 30,
   "price": 20,
   "desc": "Acrylic Removal at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-shape-polish",
   "cat": "Nails",
   "name": "Shape & Polish",
   "duration": 30,
   "price": 20,
   "desc": "Shape & Polish at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-gel-colour-no-soak-off",
   "cat": "Nails",
   "name": "Gel Colour (No Soak Off)",
   "duration": 45,
   "price": 20,
   "desc": "Gel colour, no soak off \u2014 from \u00a320.",
   "concerns": []
  },
  {
   "id": "nails-gel-colour-shellac-with-soak-off",
   "cat": "Nails",
   "name": "Gel Colour (Shellac) with Soak Off",
   "duration": 60,
   "price": 23,
   "desc": "Gel colour with soak off \u2014 from \u00a323.",
   "concerns": []
  },
  {
   "id": "nails-express-manicure",
   "cat": "Nails",
   "name": "Express Manicure",
   "duration": 30,
   "price": 30,
   "desc": "Express Manicure at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-luxury-manicure",
   "cat": "Nails",
   "name": "Luxury Manicure",
   "duration": 45,
   "price": 35,
   "desc": "Luxury Manicure at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-builder-gel-biab-colour-finish",
   "cat": "Nails",
   "name": "Builder Gel (BIAB Colour Finish)",
   "duration": 60,
   "price": 35,
   "desc": "Builder Gel BIAB colour finish \u2014 from \u00a335.",
   "concerns": []
  },
  {
   "id": "nails-builder-gel-biab-added-gel-colour-finish",
   "cat": "Nails",
   "name": "Builder Gel (BIAB Added Gel Colour Finish)",
   "duration": 60,
   "price": 39,
   "desc": "Builder Gel BIAB with added gel colour \u2014 from \u00a339.",
   "concerns": []
  },
  {
   "id": "nails-gel-colour-with-manicure",
   "cat": "Nails",
   "name": "Gel Colour with Manicure",
   "duration": 60,
   "price": 40,
   "desc": "Gel colour with manicure \u2014 from \u00a340.",
   "concerns": []
  },
  {
   "id": "nails-acrylic-infills-one-colour-finish",
   "cat": "Nails",
   "name": "Acrylic Infills (One Colour Finish)",
   "duration": 75,
   "price": 40,
   "desc": "Acrylic Infills (One Colour Finish) at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-acrylic-full-set",
   "cat": "Nails",
   "name": "Acrylic Full Set",
   "duration": 75,
   "price": 45,
   "desc": "Acrylic Full Set at Pure Birkdale.",
   "concerns": []
  },
  {
   "id": "nails-acrylic-infills-plus-nail-art",
   "cat": "Nails",
   "name": "Acrylic Infills Plus Nail Art",
   "duration": 90,
   "price": 45,
   "desc": "Acrylic Infills Plus Nail Art at Pure Birkdale.",
   "concerns": []
  }
 ]
};
